import { useTranslation } from 'react-i18next'
import MonumentoNoFoto from '../../../assets/monumento-no-foto.svg?react'
import Monumento1a10 from '../../../assets/monumento-1a10.svg?react'
import MonumentoMaggiore10 from '../../../assets/monumento-maggiore-10.svg?react'
import LegendWhite from '../../../assets/legend-white.svg?react'
import MonumentoConcorso from '../../../assets/concorso.svg?react'
import MonumentoNoConcorso from '../../../assets/no-concorso.svg?react'
import styles from './Legend.module.css'
import { getActiveGeocontext } from '../../../utils'

export default function Legend() {
  const { t } = useTranslation()
  const activeGeocontext = getActiveGeocontext()
  return (
    <div className={styles.LegendBlock}>
      <div className={styles.LegendTitle}>
        <span className="me-2">
          <LegendWhite />
        </span>
        {t('GENERIC_LEGEND')}
      </div>
      <div className={styles.CardCategorie}>
        <div className={styles.TitleCategorie}>
          {t('LEG_BOX_CATEGORY_TITLE')}
        </div>
        <div className={styles.DescCategorie}>{t('LEG_BOX_CATEGORY_TEXT')}</div>
        {activeGeocontext?.app_categories.map((category) => (
          <div key={category.id} className={styles.ItemCard}>
            <img
              src={category.icon.icon_color}
              alt={category.name}
              width={13}
              height={13}
            />
            <span className={styles.NameItem}>{t(category.name)}</span>
          </div>
        ))}
      </div>
      <div className={styles.CardColori}>
        <div className={styles.TitleCategorie}>{t('LEG_BOX_COLOR_TITLE')}</div>
        <div className={styles.DescCategorie}>{t('LEG_BOX_COLOR_TEXT_1')}</div>
        <div className={styles.ItemCard}>
          <MonumentoNoFoto />
          <span className={styles.NameItem}>{t('LEG_BOX_NUMBER_0_NONE')}</span>
        </div>
        <div className={styles.ItemCard}>
          <Monumento1a10 />
          <span className={styles.NameItem}>{t('LEG_BOX_NUMBER_1_FEW')}</span>
        </div>
        <div className={styles.ItemCard}>
          <MonumentoMaggiore10 />
          <span className={styles.NameItem}>{t('LEG_BOX_NUMBER_9_MANY')}</span>
        </div>
      </div>
      <div className={styles.CardConcorso}>
        <div className={styles.DescCategorie}>{t('LEG_BOX_COLOR_TEXT_2')}</div>
        <div className={styles.ItemCard}>
          <MonumentoConcorso />
          <span className={styles.NameItem}>{t('LEG_BOX_IN_CONTEST')}</span>
        </div>
        <div className={styles.ItemCard}>
          <MonumentoNoConcorso />
          <span className={styles.NameItem}>{t('LEG_BOX_OUT_CONTEST')}</span>
        </div>
      </div>
    </div>
  )
}
